import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const TwitterIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 19;
  const color = props.color || 'white';
  return <Icon name={'twitter'} size={size} color={color} />;
};

export default React.memo(TwitterIcon);
